<ng-container *appI18nScopeReady>
  @if (this.overviews.length === 0 && !loading()) {
    <p>{{ 'no_overview_created' | i18n }}</p>
  }
</ng-container>
